// extracted by mini-css-extract-plugin
export default {"box":"input_box__IaA-F"};